const prefixZero = val => (val < 10 ? `0${val}` : val);
const formattedDate = date => date.toLocaleDateString('en-US').split('/').map(val => prefixZero(val)).join('/');
const formattedTime = date => {
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours %= 12;
  hours = hours || 12;
  return `${prefixZero(hours)}:${prefixZero(minutes)}${ampm}`;
};

const filters = {
  titleCase: value => (
    value.replace(
      /([a-z])([A-Z])/g,
      (allMatches, firstMatch, secondMatch) => (`${firstMatch} ${secondMatch}`),
    )
      .toLowerCase()
      .replace(
        /([ -_]|^)(.)/g,
        (allMatches, firstMatch, secondMatch) => ((firstMatch ? ' ' : '') + secondMatch.toUpperCase()),
      )
  ),

  date: value => {
    if (!value) { return '-'; }

    try {
      return formattedDate(new Date(value));
    } catch (_) {
      return value;
    }
  },

  time: value => {
    if (!value) { return '-'; }

    try {
      return formattedTime(new Date(value));
    } catch (_) {
      return value;
    }
  },

  datetime: value => {
    if (!value) { return '-'; }

    try {
      const date = new Date(value);
      const dateStr = formattedDate(date);
      const timeStr = formattedTime(date);
      return `${dateStr} - ${timeStr}`;
    } catch (e) {
      return value;
    }
  },

  readableBool: val => (val ? 'Yes' : 'No'),

  dayDiff: (date1, date2) => {
    const diffTime = Math.abs(date1.getTime() - date2.getTime());
    return Math.floor(diffTime / (1000 * 60 * 60 * 24));
  },

  isEmpty: obj => {
    if (obj.constructor === Object) {
      return Object.keys(obj).every(key => (obj[key] === null || obj[key] === undefined));
    }

    if (Array.isArray(obj)) {
      return !obj.length;
    }

    return false;
  },

  title: str => {
    if (!str) { return '-'; }
    const capitalize = value => (String(value).charAt(0).toUpperCase() + String(value).slice(1).toLowerCase());
    return str.split(' ').map(capitalize).join(' ');
  },

  phone: str => {
    if (!str) { return '-'; }
    return str.replace(/^(\d{3})(\d{3})(\d{4}).*/, '($1) $2-$3');
  },

  percentage: (num, places = 2) => {
    if (num === null || num === undefined) return '-';
    return `${num.toFixed(places)} %`;
  },

  currency: value => {
    if (!value) { return '-'; }

    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    const formatted = formatter.format(value).replace('$', '');
    return `$ ${formatted}`;
  },

  readableSequence: (value, { separator = ', ', connector = 'and' } = {}) => {
    if (value && value.length === 1) {
      return value[0];
    } if (value && value.length > 1) {
      const lastIdx = value.length - 1;
      const lastItem = value[lastIdx];
      return `${value.slice(0, lastIdx).join(separator)} ${connector} ${lastItem}`;
    }
    return null;
  },
};

const AnchorFilters = {
  install(Vue) {
    Object.keys(filters).forEach(key => {
      Vue.filter(key, filters[key]);
    });
  },
};

export default AnchorFilters;
